import React from 'react';
import { Button, Spinner, sparkAssetUrl } from '@spark';
import { useEmptyState } from './useEmptyState';
import './EmptyStateCard.css';

const PROJECTS_EMPTY_ILLUSTRATION = sparkAssetUrl(
    'illustrations/illustration-projects-empty.png'
);

export const EmptyStateCard = ({
    onCreateProject,
    title = 'Welcome to Projects!',
    description = "Once you have projects, they'll appear here.",
    primaryActionText = 'Create New Specific Model',
    showPrimaryAction = true,
    primaryActionDisableWhenReadOnly = false,
    isLoading = false,
    illustrationSrc = PROJECTS_EMPTY_ILLUSTRATION,
}) => {
    const { handleCreateProject } = useEmptyState(onCreateProject);

    return (
        <div className="empty-state-container">
            {/* Content is kept in the layout (hidden) while loading so the
                card keeps the exact same size as the loaded state */}
            <div
                className={
                    isLoading
                        ? 'empty-state-content empty-state-content--hidden'
                        : 'empty-state-content'
                }
                aria-hidden={isLoading}
            >
                <div className="empty-state-icon-container">
                    <img
                        src={illustrationSrc}
                        alt=""
                        width={246}
                        height={153}
                        className="empty-state-illustration"
                    />
                </div>

                <h2 className="empty-state-title">{title}</h2>

                <p
                    className={
                        showPrimaryAction
                            ? 'empty-state-description'
                            : 'empty-state-description empty-state-description--no-cta'
                    }
                >
                    {description}
                </p>

                {showPrimaryAction ? (
                    <Button
                        variant="primary"
                        size="large"
                        disableWhenReadOnly={primaryActionDisableWhenReadOnly}
                        onClick={handleCreateProject}
                        className="empty-state-action-button"
                    >
                        {primaryActionText}
                    </Button>
                ) : null}
            </div>

            {isLoading ? (
                <div className="empty-state-loading">
                    <Spinner size="large" />
                </div>
            ) : null}
        </div>
    );
};
